export const VERSION = '0.3.3'; // x-release-please-version
//# sourceMappingURL=version.mjs.map